import script from "./PriceFormatter.vue?vue&type=script&lang=ts&setup=true"
export * from "./PriceFormatter.vue?vue&type=script&lang=ts&setup=true"

import "./PriceFormatter.vue?vue&type=style&index=0&id=27a740e5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27a740e5"]])

export default __exports__